import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-stepper-header',
  standalone: false,
  templateUrl: './stepper-header.component.html',
  styleUrl: './stepper-header.component.scss',
})
export class StepperHeaderComponent {
  @Input() steps: any[] = [];

  @Input() currentStep: number = 0;

  get normalizedCurrentStep(): number {
    if (!this.steps.length) return 0;
    return Math.min(Math.max(Math.trunc(this.currentStep), 1), this.steps.length);
  }

  get progressPercent(): number {
    if (this.steps.length < 2) return 0;
    return ((this.normalizedCurrentStep - 1) / (this.steps.length - 1)) * 100;
  }

  get currentStepName(): string {
    return this.steps[this.normalizedCurrentStep - 1]?.name || '';
  }
}
